// dependencies
import React from "react";
import camelCase from "camelcase";
import PropTypes from "prop-types";

// config
import browsers from "Config/browserImages";

// style
import css from "./BrowserLogo";

class BrowserLogo extends React.PureComponent {
	static propTypes = {
		size: PropTypes.number,
		className: PropTypes.string,
		name: PropTypes.string.isRequired,
	};

	static defaultProps = {
		className: "",
		size: 100,
	};

	state = {
		hasError: false,
	};

	componentDidCatch = () => {
		this.setState({ hasError: true });
	};

	render = () => {
		const { hasError } = this.state;
		const { name, size, className } = this.props;

		if (hasError) {
			return null;
		}

		const normalizedName = name ? camelCase(name) : "";
		const browserPath = browsers.get(normalizedName, browsers.get("default"));

		return (
			<div className={`${css.logoWrapper} ${className}`}>
				<img alt={name} height={size} width={size} src={`${browserPath}`} />
			</div>
		);
	};
}

export default BrowserLogo;
